import PageHead from "../Head";
import HeaderContainer from "@/my_components/Header/HeaderContainer";
import Separator from "@/components/Common/Separator";
import HomePageContents from "@/my_components/_HomePage/Home";
import MobileMenu from "@/my_components/Header/MobileMenu";
import Context from "@/context/Context";
import Footer from "@/my_components/Footer/Footer";

const Home = () => {
  return (
    <>
      <PageHead title="Home | SmartTech Academy" />

        <Context>
          <MobileMenu />
          <HeaderContainer headerSticky="rbt-sticky" headerType="" topBarToggle="off" blendWithHero />
          <HomePageContents />

          <Separator /> 
          <Footer /> 
        </Context>
    </>
  );
};

export default Home;
